( function () {
    'use strict';
    /**
     * Utillities / Helpers
     * @namespace
     */
    master.utils = {
        /** @function */
        /**
         * Async append new stylesheet

         * @param {String} href - Link to stylesheet
         * @returns jQuery.Promise

         * @async
         */
        getStylesheet: function ( href ) {
            var jDeferred = jQuery.Deferred(),
                jLink     = jQuery( '<link/>', {
                    rel: 'stylesheet',
                    type: 'text/css',
                    href: href
                } ).appendTo( 'head' );
            jDeferred.resolve( jLink );
            return jDeferred.promise();
        },
        getScript: function ( objScript, fnCallback, arrCallbackArgs ) {
            var ajax = function ( strURL ) {
                if ( strURL !== undefined && strURL !== null && strURL !== '' ) {
                    return jQuery.ajax( {
                        url: strURL,
                        cache: true,
                        timeout: master.scripts.vendor.timeout,
                        dataType: 'script'
                    } );
                }
                else {
                    return jQuery.Deferred().reject();
                }
            };
            if ( objScript.promise === undefined || objScript.promise.state() === 'rejected' ) {
                objScript.promise = jQuery.when(
                        master.utils.getScriptAjax( objScript.url )
                ).then( null, function () {
                    return master.utils.getScriptAjax( objScript.fallback );
                } ).then( function () {
                    if ( typeof objScript.callback === 'function' ) {
                        objScript.callback.apply( objScript );
                    }
                } );
            }
            if ( typeof fnCallback === 'function' ) {
                objScript.promise.done( function () {
                    fnCallback.apply( window, arrCallbackArgs );
                } );
            }
            return objScript.promise;
        },
        getScriptAjax: function ( strURL ) {
            if ( strURL !== undefined && strURL !== null && strURL !== '' ) {
                return jQuery.ajax( {
                    url: strURL,
                    cache: true,
                    timeout: master.scripts.vendor.timeout,
                    dataType: 'script'
                } );
            }
            else {
                return jQuery.Deferred().reject();
            }
        },
        autoSessionExtender: function(intSessionUpdateTime){
            if(typeof window.autoSessionExtender === 'undefined'){
                window.autoSessionExtender = 1;
                setInterval(function(){
                    var xhr = new XMLHttpRequest();
                    var cachebuster = Math.floor(Math.random()*new Date().getTime());
                    xhr.open('GET', '/autosessionextender?_=' + cachebuster);
                    xhr.send(null);
                }, intSessionUpdateTime);
            }
            
        },
        /** @function */
        /**
         * Log to console

         * @param {Object} args - Arguments to display in console
         * @param {String} logType - Type of console (eg. log, error, dir)
         */
        log: function ( args, logType ) {
            if ( master.settings.debug === true ) {
                console[ logType || 'log' ]( args );
            }
        },
        /** @function */
        /**
         * Check for mobile device

         * @param {String} a - Argument to test against
         * @returns true/false
         */
        isMobile: function ( a ) {
            return ( /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test( a ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test( a.substr( 0, 4 ) ) );
        },
        /** @function */
        /**
         * Range selection in an element

         * @param {String} element - Dom element to use for selection
         */
        isTest: function(){
            return location.href.indexOf('espresso.dw.webtester') > -1;
        },
        selectAll: function ( element ) {
            var doc = document;
            var range;
            if ( doc.body.createTextRange ) {
                range = document.body.createTextRange();
                range.moveToElementText( element );
                range.select();
            }
            else if ( window.getSelection ) {
                var selection = window.getSelection();
                range = document.createRange();
                range.selectNodeContents( element );
                selection.removeAllRanges();
                selection.addRange( range );
            }
        },
        /** @function */
        /**
         * Bootstrap popover

         */
        popover: function () {
            jQuery( '[data-popover]' ).popover();
            jQuery( document ).on( 'click', '.popover.in', function () {
                jQuery( this ).prev( '[data-popover]' ).popover();
                jQuery( this ).remove();
            } );
        },
        /** @function */
        /**
         * Custom tooltip

         */
        tooltip: function () {
            jQuery( '[data-tooltip]' ).each( function () {
                var jSelector = jQuery( this ),
                    options   = {
                        content: jSelector.data( 'tooltip' ) !== '' ? jSelector.data( 'tooltip' ) : jSelector.prop( 'title' ),
                        position: 'top',
                        show: {
                            top: '100%',
                            opacity: 1
                        }
                    };
                jSelector.on( 'touchstart mouseover', function () {
                    var jTooltip = jQuery( '<div class="tooltip">' + options.content + '</div>' );
                    jSelector.after( jTooltip );
                    setTimeout( function () {
                        jQuery( jTooltip ).css( options.show );
                    }, 100 );
                } ).on( 'touchend mouseout', function () {
                    jQuery( this ).next( '.tooltip' ).remove();
                } );
            } );
        },
        /** @function */
        /**
         * Page preloader

         * @param {Boolean} show - Bool to check if preloader should be shown of hidden
         */
        preloader: function ( show ) {
            if ( show === true ) {
                jQuery( '.js-page-preloader' ).addClass( 'loading' ).fadeIn( master.settings.animateSpeed );
            }
            else if ( show === false ) {
                jQuery( '.js-page-preloader' ).removeClass( 'loading' ).fadeOut( master.settings.animateSpeed );
            }
            else {
                setTimeout( function () {
                    jQuery( '.js-page-preloader' ).removeClass( 'loading' ).fadeOut( master.settings.animateSpeed );
                }, 500 );
            }
        },
        /** @function */
        /**
         * String / Int Array sorter

         * @param {String} m - Type of array items
         * @param {Array} a - Array to sort
         * @param {Array} b - Array to sort
         * @returns array / int
         */
        sortArr: function ( m, a, b ) {
            if ( m === 'int' ) {
                return a - b;
            }
            else if ( m === 'str' ) {
                if ( a < b ) {
                    return -1;
                }
                else if ( a === b ) {
                    return 0;
                }
                else if ( a > b ) {
                    return 1;
                }
            }
        },
        /** @function */
        /**
         * Show / hide templating

         * @deprecated since version 2.0
         */
        templating: function ( parent, identifier, content, action ) {
            var jTarget = jQuery( parent ).find( '[data-tpl="' + identifier + '"]' );
            if ( content !== null ) {
                if ( action === 'hide' ) {
                    jTarget.fadeOut();
                }
                else if ( action === 'show' ) {
                    jTarget.html( content );
                    jQuery( parent ).fadeIn();
                }
                else {
                    jTarget.fadeOut().html( content ).fadeIn();
                }
            }
        },
        /**
         * SVG namespace
         * @namespace

         */
        svg: {
            /** @function */
            /**
             * Store svgs in session storage

             * @param {String} imgURL - Image/svg urls
             * @param {String} svg - SVG html
             * @param {String} svgID - SVG ID
             */
            store: function ( imgURL, svg, svgID ) {
                var svgRepo = master.store.session.svgRepo;
                svgRepo[ svgID ] = svg;
                master.store.session.set( 'svg-repo', JSON.stringify( svgRepo ) );
            },
            /** @function */
            /**
             * Convert image to svg-code

             * @param {Integer} index - Image DOM index
             * @param {Object} img - The jQuery DOM element to replace
             * @param {String} imgClass - String of image classes
             * @param {String} imgURL - Image url
             * @param {String} svgID - ID of the SVG
             */
            convert: function ( index, img, imgClass, imgURL, svgID ) {
                var that = this;
                jQuery.get( imgURL, function ( data ) {
                    var svg = jQuery( data ).find( 'svg' );
                    if ( typeof imgClass !== undefined ) {
                        svg = svg.attr( 'class', imgClass );
                    }
                    svg = svg.removeAttr( 'xmlns:a' );
                    that.store( imgURL, svg.prop( 'outerHTML' ), svgID );
                    that.insert( index, img, svg );
                }, 'xml' );
            },
            /** @function */
            /**
             * Insert converted svg-code into DOM

             * @param {Integer} index - Image DOM index
             * @param {Object} img - The jQuery DOM element to replace
             * @param {Object} svg - The SVG code
             */
            insert: function ( index, img, svg ) {
                img.replaceWith( svg );
                setTimeout( function () {
                    svg.addClass( 'svgo' );
                }, 100 + ( index * 10 ) );
            },
            /** @function */
            /**
             * Initialize svg namespace

             */
            init: function () {
                var that    = this,
                    svgRepo = master.store.session.svgRepo;
                jQuery( 'img.svg' ).each( function ( index ) {
                    var img      = jQuery( this ),
                        imgClass = img.attr( 'class' ),
                        imgURL   = img.attr( 'src' ),
                        svgID    = /[^/]*$/.exec( imgURL )[ 0 ].replace( '.svg', '' );
                    if ( svgRepo[ svgID ] !== undefined ) {
                        that.insert( index, img, jQuery( svgRepo[ svgID ] ) );
                    }
                    else {
                        that.convert( index, img, imgClass, imgURL, svgID );
                    }
                } );
            }
        },
        /**
         * @namespace
         * @property {Integer} options.upperLimit  - levenshteinDistance upper limit.
         * @property {Integer} options.lowerLimit - levenshteinDistance lower limit.
         */
        spellCheck: {
            options: {
                upperLimit: 10,
                lowerLimit: 2
            },
            matcher: function ( query ) {
                var cities = JSON.parse( master.store.local.zipcodes );
                /*upperLimit = this.options.upperLimit;*/
                for ( var i = 0; i < cities.length; i++ ) {
                    /*
                     var levenshteinDistance = this.levenshtein( query.toLowerCase(), cities[ i ].City.toLowerCase() );
                     if ( levenshteinDistance < upperLimit ) {
                     upperLimit = levenshteinDistance;
                     if ( upperLimit <= this.options.lowerLimit ) {
                     return cities[ i ].City;
                     }
                     else {
                     var returnResult = this.findInArr( query, cities )
                     if ( returnResult.length ) {
                     return this.findInArr( query, cities )[ 0 ].City;
                     }
                     else {
                     return false;
                     }
                     }
                     }
                     */
                    var returnResult = this.findInArr( query, cities );
                    if ( returnResult.length ) {
                        return this.findInArr( query, cities )[ 0 ].City;
                    }
                    else {
                        return false;
                    }
                }
            },
            findInArr: function ( key, array ) {
                var results = [];
                for ( var i = 0; i < array.length; i++ ) {
                    if ( array[ i ].City.toLowerCase().indexOf( key.toLowerCase() ) > -1 ) {
                        results.push( array[ i ] );
                    }
                }
                return results;
            },
            levenshtein: function ( a, b ) {
                if ( !a || !b ) {
                    return ( a || b ).length;
                }
                var m = [];
                for ( var i = 0; i <= b.length; i++ ) {
                    m[ i ] = [ i ];
                    if ( i === 0 ) {
                        continue;
                    }
                    for ( var j = 0; j <= a.length; j++ ) {
                        m[ 0 ][ j ] = j;
                        if ( j === 0 ) {
                            continue;
                        }
                        m[ i ][ j ] = b.charAt( i - 1 ) === a.charAt( j - 1 ) ? m[ i - 1 ][ j - 1 ] : Math.min( m[ i - 1 ][ j - 1 ] + 1, m[ i ][ j - 1 ] + 1, m[ i - 1 ][ j ] + 1 );
                    }
                }
                return m[ b.length ][ a.length ];
            }
        },
        scrollToTop: function () {
            jQuery( '.js-e-footer' ).find( '.js-e-footer-container' ).prepend( '<div class="master-utility-scroll-to-top js-master-utility-scroll-to-top" />' );
            jQuery( '.js-master-utility-scroll-to-top' ).html( '<i class="material-icons">keyboard_arrow_up</i>' );
            jQuery( '.js-e-footer' ).on( 'click', '.js-master-utility-scroll-to-top, [data-toggle="modal"]', function () {
                co3.util.scroll.toPosition( 0 );
            } );
            espresso.constant.jWindow.on( 'scroll', function () {
                if ( jQuery( this ).scrollTop() > ( espresso.constant.jWindow.height() * 1.5 ) ) {
                    jQuery( '.js-master-utility-scroll-to-top' ).addClass( 'is-visible' );
                }
                else {
                    jQuery( '.js-master-utility-scroll-to-top' ).removeClass( 'is-visible' );
                }
            } );
        },
        moveUspBar: function () {
            jQuery( '.uspBar' ).detach().appendTo( '.js-e-nav-global-top' );
        },
        breakIntoColumns: function () {
            var num_cols  = 2,
                container = jQuery( '.js-equal-columns ul' ),
                listItem  = 'li',
                listClass = 'equal-columns-list';
            container.each( function () {
                var items_per_col     = [],
                    items             = jQuery( this ).find( listItem ),
                    min_items_per_col = Math.floor( items.length / num_cols ),
                    difference        = items.length - ( min_items_per_col * num_cols );
                for ( var i = 0; i < num_cols; i++ ) {
                    if ( i < difference ) {
                        items_per_col[ i ] = min_items_per_col + 1;
                    }
                    else {
                        items_per_col[ i ] = min_items_per_col;
                    }
                }
                for ( i = 0; i < num_cols; i++ ) {
                    jQuery( this ).append( jQuery( '<ul ></ul>' ).addClass( listClass ) );
                    for ( var j = 0; j < items_per_col[ i ]; j++ ) {
                        var pointer = 0;
                        for ( var k = 0; k < i; k++ ) {
                            pointer += items_per_col[ k ];
                        }
                        jQuery( this ).find( '.' + listClass ).last().append( items[ j + pointer ] );
                    }
                }
                jQuery( this ).find( 'ul' ).unwrap().fadeIn().last().after( '<div class="global-helper--clear">' );
            } );
        },
        helpers: {
            init: function () {
                master.utils.helpers.trimInputValues();
            },
            trimInputValues: function () {
                jQuery( '.js-helper-trim-input-value' ).on( 'keyup input', function () {
                    var preValue = jQuery( this ).val().replace( /\s/g, '' );
                    jQuery( this ).val( preValue );
                } );
            }
        },
        init: function () {
            this.svg.init();
            this.preloader();
            this.popover();
            this.tooltip();
            this.scrollToTop();
            this.moveUspBar();
            this.breakIntoColumns();
            master.utils.helpers.init();
        }
    };
}() );
